<!-- <app-header [title]="Title"></app-header> -->
<p>
  <!-- payment-report works! -->
  
  <!-- <iframe _ngcontent-irq-c2="" height="700px" src="https://app.powerbi.com/view?r=eyJrIjoiYzJhZWE0ZmYtYTZhNC00NmY2LTkwYzEtNzk0YWI2NGZlNDViIiwidCI6ImE0ZTU2MTU2LTRjYjQtNGVjMS04ZWFlLThlYjI0Y2VjYjc3MCIsImMiOjZ9" width="100%"></iframe> -->

  <!-- <iframe _ngcontent-irq-c2="" height="700px" src="https://app.powerbi.com/view?r=eyJrIjoiM2MwNzMxMDItNTY4Mi00ODQ3LWEzMzItOWI4MjA5MjM4NjI2IiwidCI6ImE0ZTU2MTU2LTRjYjQtNGVjMS04ZWFlLThlYjI0Y2VjYjc3MCIsImMiOjZ9" width="100%"></iframe> -->

  <iframe _ngcontent-irq-c2="" height="700px" [src]="urlSafe" width="100%"></iframe>
</p>
